// MessageWrapper.tsx
import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { dateFormate } from '../../utils/helper';

interface MessageWrapperProps {
  message: any;
  children: React.ReactNode;
}

const getStatusIcon = (statusType: string | undefined) => {
  switch (statusType?.toLowerCase()) {
    case 'sent':
    case 'sent to meta':
    case 'new message sent':
      return <DoneIcon fontSize="small" sx={{ color: '#6c757d' }} />;
    case 'delivered':
      return <DoneAllIcon fontSize="small" sx={{ color: '#6c757d' }} />;
    case 'read':
      return <DoneAllIcon fontSize="small" sx={{ color: '#4F6DF9' }} />;
    default:
      return <DoneIcon fontSize="small" sx={{ color: '#6c757d' }} />;
  }
};

const MessageDesign: React.FC<MessageWrapperProps> = ({ message, children }) => {
  const isBot = message?.origin === 'INBOUND';

  let timestamp = '';
  if (message?.timestamp) {
    const date = new Date(message.timestamp * 1000);
    timestamp = dateFormate(date, 'h:mm A');
  }

  const getMessageByText = (message: any) => {
    if (message?.chat_type === 'bot') {
      return 'Message by: Bot';
    }

    if (message?.chat_type === 'human_agent' && message?.intervened_by) {
      return `Message by: ${message?.intervened_by}`;
    }
    return '';
  };

  return (
    <Box mb={1}>
      <Box
        display="flex"
        justifyContent={isBot ? 'flex-start' : 'flex-end'}
        mb="5px"
        className={isBot ? 'chat-wrapper-first' : 'chat-wrapper-second'}
      >
        <Paper
          elevation={3}
          sx={{
            maxWidth: { xs: "338px", sm: "500px" },
            p: '10px 30px 10px 14px',
            backgroundColor: isBot ? 'white' : '#D7DEFF',
            color: 'black',
            borderRadius: isBot ? '0px 24px 24px 24px' : '24px 0px 24px 24px',
            position: 'relative',
            wordBreak: 'break-word',
          }}
        >
          {children}

          {!isBot && (
            <Box
              sx={{
                position: 'absolute',
                bottom: 0,
                right: 4,
                // display: 'flex',
                alignItems: 'center',
              }}
              title={message?.status?.type || 'sent'}
            >
              {getStatusIcon(message?.status?.type ?? message?.status)}
            </Box>
          )}
        </Paper>
      </Box>

      <Box display="flex" justifyContent={isBot ? 'flex-start' : 'flex-end'}>
        <Typography variant="caption" color="textSecondary">
          {timestamp}
        </Typography>
        {getMessageByText(message) && !isBot && (
          <Typography variant="caption" color="textSecondary">
            • {getMessageByText(message)}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default MessageDesign;
